import type { WidgetLauncherVisual } from '../../features/onboarding/widgetLauncherVisual';

/** ホームの見た目ドラフトを、embed.js が読むウィジェット設定の形にする。 */
export function launcherVisualToWidgetSettings(visual: WidgetLauncherVisual) {
  return {
    theme: 'light' as const,
    edge: visual.edge,
    position: {
      preset: visual.positionPreset,
      offset: visual.offset,
    },
    widgetPosition: visual.widgetPosition,
    widgetOffset: visual.widgetOffset,
    widgetWidth: visual.widgetWidth,
    closeOnOutsideClick: false,
    dimBackground: visual.dimBackground,
    locale: 'ja' as const,
    button: {
      buttonType: visual.buttonType,
      text: visual.text,
      textColor: visual.textColor,
      fontSize: visual.fontSize,
      fontWeight: visual.fontWeight,
      fontFamily: visual.fontFamily,
      writingMode: visual.writingMode,
      tcyEnabled: visual.tcyEnabled,
      backgroundColor: visual.backgroundColor,
      borderColor: visual.borderColor,
      borderWidth: visual.borderWidth,
      width: visual.width,
      height: visual.height,
      borderRadius: visual.borderRadius,
      paddingY: visual.paddingY,
      paddingX: visual.paddingX,
      imageUrl: visual.imageUrl,
      imageFit: visual.imageFit,
      imageMode: visual.imageMode,
      showCloseButton: visual.showCloseButton,
      icon: visual.icon
        ? { enabled: true, ...visual.icon }
        : { enabled: false, url: '', size: 20, color: '#ffffff', colorEnabled: true, position: 'before' as const },
    },
    closeButton: visual.closeButton,
    tooltip: visual.tooltip,
  };
}
